import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { ServerResponse } from '../models/types';
import { NhanVien } from '../models/employees.model';
import { User_CP } from '../models/user.model';
import { AuthenticationService } from './authentication.service';
import { JWTService } from './JWTService';
import * as localForage from 'localforage';
import { GetLocalForageConFigService } from './getLocalForage.service';

@Injectable()
export class EmployeesService {

    url = '';

    constructor(
      private http: HttpClient,
      private jwtService: JWTService,
      private getlocalconfig: GetLocalForageConFigService,
        private storeNV: Store<NhanVien[]>,
        @Inject('BASE_URL') baseUrl: string
    ) {
        this.url = baseUrl;
    }

    async getNhanVien(value: string) {
        return this.http.post(this.url + 'api/NhanVien/nhanvien', { MaCH: value })
        .toPromise()
        .then((result: ServerResponse) => {
            if (result[0].code === 1) {
            this.storeNV.dispatch({ type: 'INIT_NhanVien', nv: result[0].data });
            // console.log(result[0].data);
            return Promise.resolve(result[0].data);
            } else {
            return Promise.reject(null);
            }
        });
    }
async  changePass(user_cp: NhanVien, us_cp: User_CP) {
    user_cp.MatKhau = us_cp.newPass;
    return this.http.post(this.url + 'api/NhanVien/setnhanvien_password',  user_cp)
      .toPromise()
      .then(async (result: ServerResponse) => {
        if (result[0].code === 1) {
          await this.getNhanVien(user_cp.MaCH)
            .then((result: Array<NhanVien>) => {
              console.log(result);
              const str = this.jwtService.enCryptData(result);
              this.getlocalconfig.getConfigLocalForage()
                .then(async result => {
                  localForage.setItem('_dsNV', str);
                })
                .catch(err => {
                  console.log(err);
                });
            });
          return Promise.resolve(result[0].code);
        } else {
          return Promise.reject(null);
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/employees.service.ts